import { TBreakpointNames, breakpoints } from '../../utils';

export const getCurrentBreakpoint = (): TBreakpointNames => {
  let currentBreakpoint: TBreakpointNames;
  const width = window.innerWidth;

  if (width < breakpoints.xs) {
    currentBreakpoint = 'xxs';
  } else if (width < breakpoints.sm) {
    currentBreakpoint = 'xs';
  } else if (width < breakpoints.md) {
    currentBreakpoint = 'sm';
  } else if (width < breakpoints.lg) {
    currentBreakpoint = 'md';
  } else if (width < breakpoints.xl) {
    currentBreakpoint = 'lg';
  } else if (width < breakpoints.xxl) {
    currentBreakpoint = 'xl';
  } else {
    currentBreakpoint = 'xxl';
  }

  return currentBreakpoint;
};

/**
 * Helper function to check if the current breakpoint is equal to or larger than the specified breakpoint.
 *
 * @param {TBreakpointNames} breakpoint - The breakpoint to check against.
 * @returns {boolean} - True if the current breakpoint is equal to or larger than the specified breakpoint, false otherwise.
 */
export const isBreakpointEqualOrLarger = (breakpoint: TBreakpointNames): boolean => {
  return window.innerWidth >= breakpoints[breakpoint];
};

/**
 * Helper function to check if the current breakpoint is equal to or smaller than the specified breakpoint.
 *
 * @param {TBreakpointNames} breakpoint - The breakpoint to check against.
 * @returns {boolean} - True if the current breakpoint is equal to or smaller than the specified breakpoint, false otherwise.
 */
export const isBreakpointEqualOrSmaller = (breakpoint: TBreakpointNames): boolean => {
  return window.innerWidth <= breakpoints[breakpoint];
};

/**
 * Helper function to check if the current breakpoint is between the specified breakpoints.
 *
 * @param {TBreakpointNames} min - The start breakpoint.
 * @param {TBreakpointNames} max - The end breakpoint.
 * @returns {boolean} - True if the current breakpoint is between the specified breakpoints, false otherwise.
 */
export const isBreakpointBetween = (min: TBreakpointNames, max: TBreakpointNames): boolean => {
  return window.innerWidth >= breakpoints[min] && window.innerWidth < breakpoints[max];
};

/**
 * Helper function to check if the current breakpoint is strictly larger than the specified breakpoint.
 *
 * @param {TBreakpointNames} breakpoint - The breakpoint to check against.
 * @returns {boolean} - True if the current breakpoint is larger than the specified breakpoint, false otherwise.
 */
export const isBreakpointLarger = (breakpoint: TBreakpointNames): boolean => {
  return window.innerWidth > breakpoints[breakpoint];
};

/**
 * Helper function to check if the current breakpoint is strictly smaller than the specified breakpoint.
 *
 * @param {TBreakpointNames} breakpoint - The breakpoint to check against.
 * @returns {boolean} - True if the current breakpoint is smaller than the specified breakpoint, false otherwise.
 */
export const isBreakpointSmaller = (breakpoint: TBreakpointNames): boolean => {
  return window.innerWidth < breakpoints[breakpoint];
};
